// var Crypto=exports.Crypto=require("./lib/Crypto").Crypto;

// ["CryptoMath","BlockModes","DES","MD5"].forEach(function(path){require("./lib/"+path)});

var Crypto = {
	'test':1,
	'Crypto':require("./lib/Crypto.js"),
	'CryptoMath':require("./lib/CryptoMath.js"),
	'BlockModes':require("./lib/BlockModes.js"),
	'DES':require("./lib/DES.js"),
	'MD5':require("./lib/MD5.js")
}

module.exports = Crypto;


// WEBPACK FOOTER //
// ./src/assets/js/cryptojs/cryptojs.js